import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { Card, Icon } from 'antd';

import DetailsBookingComponent from './DetailsBookingComponent';
import { setIcon } from '../../services/setIcon'
import { showAntModal } from '../../actions/globalActions';

import './style.css';

const BookingBoxComponent = ({ mode, booking, head, action, alert, history }, context) => {
  return (
    <Card className="booking-box">
      {head && (
        <p className="text-gray-link info-head">
          <span className="uppercase text-sm">{head}</span>
          {alert && (
            <span
              className={`info-head-alert ${alert.colorClass || ''}`}>{alert.name}</span>
          )}
        </p>
      )}
      <div className="flex flex-col lg:block">
        <div className="box-hotel booking-code mb-6 lg:mb-0">
          <h3>{booking.hotelName}</h3>
          <h4 className="text-gray-link">{context.t('Booking reference')}:
            <span className="ml-1 text-gray-700">{booking.locator}</span>
          </h4>
        </div>
        {action && (
          <div className="flex justify-between items-center -mt-2 order-last lg:order-none">
            <div className="flex-1 h-1 border-b border-gray-300" />
            <div className="flex justify-between lg:block w-full lg:w-auto text-right lg:px-6 mt-4">
              <div className="App-link" onClick={() => showAntModal({
                title: context.t('Hotel Contact'),
                content: (
                  <div>
                    <p><b>{context.t('Phone number')}:</b> {action.phone}</p>
                    <p><b>{context.t('Email')}:</b> {action.email}</p>
                    <p><b>{context.t('Address')}:</b> {action.address}</p>
                  </div>
                ),
              })}>
                <span className="text-xs">{context.t('Contact Resort')}</span>
                <Icon component={setIcon('setting')} className="ml-2" />
              </div>
              <div className="App-link" onClick={() => history.push(`/catalogue/${booking.hotelId}`) }>
                <span className="text-xs">{context.t('Enrich your stay')}</span>
                <Icon component={setIcon('contact')} className="ml-2" />
              </div>
            </div>
          </div>
        )}
        <DetailsBookingComponent mode={mode} booking={booking}/>
      </div>
    </Card>
  );
}

BookingBoxComponent.propTypes = {
  mode: PropTypes.string,
  booking: PropTypes.object,
  head: PropTypes.string,
  alert: PropTypes.object,
  action: PropTypes.object,
}

BookingBoxComponent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default withRouter(BookingBoxComponent);
